import { render, staticRenderFns } from "./ChamadasInscricoesTable.vue?vue&type=template&id=5ceb41a2&scoped=true"
import script from "./ChamadasInscricoesTable.vue?vue&type=script&lang=js"
export * from "./ChamadasInscricoesTable.vue?vue&type=script&lang=js"
import style0 from "./ChamadasInscricoesTable.vue?vue&type=style&index=0&id=5ceb41a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb41a2",
  null
  
)

export default component.exports